"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InternalNoteInput = exports.InternalNote = exports.IssuePartyTypeLabels = exports.IssuePartyType = exports.IssuePartyTypes = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.IssuePartyTypes = ['sourgum', 'customer', 'vendor'];
exports.IssuePartyType = typebox_1.Type.Union(exports.IssuePartyTypes.map((type) => typebox_1.Type.Literal(type)));
exports.IssuePartyTypeLabels = {
    sourgum: 'Sourgum',
    customer: 'Customer',
    vendor: 'Vendor',
};
exports.InternalNote = typebox_1.Type.Object({
    note: typebox_1.Type.String(),
    isIssue: typebox_1.Type.Boolean(),
    issueParty: typebox_1.Type.Optional(exports.IssuePartyType),
    responsibleUserID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    monetaryLoss: typebox_1.Type.Optional(typebox_1.Type.Number()),
    serviceOrderID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    userID: typebox_1.Type.String({ format: 'uuid' }),
    timestamp: typebox_1.Type.String({ format: 'date-time' }),
});
exports.InternalNoteInput = typebox_1.Type.Omit(exports.InternalNote, ['userID', 'timestamp']);
//# sourceMappingURL=internal-note.js.map